export default {"src":"/_next/static/media/musicplay_icon.57c11351.webp","height":437,"width":777,"blurWidth":0,"blurHeight":0};